<template>
    <div>
        <!-- 搜索 -->
        <search  :search="true" :type="'MenuManagement'" @add-data="add_data" @search-data="search_data" @Export="Export"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData"  :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增菜单 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Menu" :title="title"  :width="'720px'" v-if="New_Menu">
            <NewMenu :visibles.sync="New_Menu" @Render="Render" :type="type" :row="row"></NewMenu>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
    </div>
</template>
<script>
import NewMenu from '../dialog/NewMenu'
export default {
  components: {
    NewMenu
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      New_Menu: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10,
        orders: 'sortValue|asc,id|asc'
      },
      tableData: [
      ],
      tableLabel: [
        { label: '序号', width: '60', prop: 'index', type: '', align: 'center' },
        { label: '菜单名称', width: '200', prop: 'name', align: 'center' },
        { label: '路径地址', width: '', prop: 'link', align: 'center' },
        { label: '描述', width: '', prop: 'description', align: 'center' },
        { label: '父级菜单名称', width: '', prop: 'parentName', align: 'center' },
        {
          label: '操作',
          width: '260',
          align: 'center',
          isOpera: true, // 判断是否生成按钮
          ifshow: false, // 是否导出该内容
          titleList: [
            {
              title: '新增菜单',
              status: 'primary'
            },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // 新增
    add_data (v) {
      this.title = '新增菜单'
      this.New_Menu = true
      this.type = 'add'
      this.row = {}
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
      this.tableLabel[6].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '菜单信息.xlsx')
        this.tableLabel[6].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_Menu = true
        this.title = '修改菜单'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm(`此操作将永久删除<span style="color:red"> ${row.name} </span> 该菜单, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true // 将dangerouslyUseHTMLString属性设置为 true，message 就会被当作 HTML 片段处理
        }).then(() => {
          this.$http.Delete('/ucenter/menu/deleteMenu', { id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '新增菜单') {
        this.New_Menu = true
        this.title = '新增菜单'
        this.type = 'AddMenu'
        this.row = row
      }
    },
    // 列表数据
    Render () {
      this.$http.get('/ucenter/menu/queryPage', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
      // this.$http.get('/dict/department/queryPageTree', this.matterParams).then((res) => {
      //   this.tableData = res.data.records
      //   this.tableData = res.data.records
      //   this.total = res.data.total
      // })
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
    // .main{
    //     display: flex;
    //     height: 800px;
    //     padding: 20px 0px 0 50px;
    //     .right{
    //        background: green;
    //        width: 100%;
    //        height: 100%;
    //     }
    // }
</style>
